import {Model} from "ords/dist/model/model";
import {AssignmentStatusLog} from "../assignment/AssignmentStatusLog";

export class AfaqCategory extends Model {

}

export const AfaqCategoryModelConfig = {
    name: 'AfaqCategory',
    model: AfaqCategory,
    relations: [
         {name: 'afaq_question_answers', model_name: 'AfaqQuestionAnswer', type: 'hasMany'},
    ]
}

